import { struct } from 'io-ts/Decoder';

import { Id as ParameterId } from '../../../../whole-house/additional-parameter/Id';

export const Param = struct({
	parameterId: ParameterId,
});
